module.exports = __webpack_public_path__ + "img/sand-decal-03.dfe9c95f.png";